import React from 'react';

import { Redirect } from 'react-router';

import {
  Badge,
  Grid,
  IconButton,
  Tooltip,
} from '@material-ui/core';

import {
  ErrorOutline as InputFailedIcon,
  SkipNext as InputSkippedIcon, 
  ThreeSixty as InputRetriedIcon,
  ThumbDown as InputRejectedIcon, 
} from '@material-ui/icons';


import {
  ExecutionMessages,
} from '../components';

function fmtIssueTooltip(count, type) {
  return count+" "+type+" input"+(count===1?"":"s");
}

export function fmtExecutionIssues(execution) {
  
  const [executionIssues, setExecutionIssues] = React.useState(null);

  const issuesStyle = {
    display: 'flex',
    justifyContent: 'flex-end'
  };

  const issueStyle = {
    leftPadding: '8px',
  };

  const iconButtonSize="small";  
  const fontSize="default";
  const badgeMax=9999;
  const badgeColor="default";

  if(!execution) {
    return(null);
  }
  
  const inputs=execution.Inputs || {};
  const rejected=inputs.Rejected?inputs.Rejected.Objects:0;
  const skipped=inputs.Skipped?inputs.Skipped.Objects:0;
  const retried=inputs.Retried?inputs.Retried.Objects:0;
  const failed=inputs.Failed?inputs.Failed.Objects:0;
  
  const handleClickFailed = () => {
      setExecutionIssues('FAILED');
  };
  const handleClickSkipped = () => {
      setExecutionIssues('SKIPPED');
  };
  const handleClickRejected = () => {
      setExecutionIssues('REJECTED');
  };

  if(executionIssues) {
    return <Redirect push to={"/executions/"+execution.ExecutionId+"?inputs="+executionIssues} />;  
  }
  
  return(
    <div style={issuesStyle}>
      <ExecutionMessages execution={execution} />
      { rejected>0 &&
        <div style={issueStyle}>
          <Tooltip title={fmtIssueTooltip(rejected,"rejected")}>
            <IconButton size={iconButtonSize} onClick={handleClickRejected}>
              <Badge badgeContent={rejected} color={badgeColor} max={badgeMax}>
                <InputRejectedIcon fontSize={fontSize}/>
              </Badge>
            </IconButton>
          </Tooltip>
        </div>
      }
      { skipped>0 &&
        <div style={issueStyle}>
          <Tooltip title={fmtIssueTooltip(skipped,"skipped")}>
            <IconButton size={iconButtonSize} onClick={handleClickSkipped}>
              <Badge badgeContent={skipped} color={badgeColor} max={badgeMax}>
                <InputSkippedIcon fontSize={fontSize} style={{fill: "orange"}}/>
              </Badge>
            </IconButton>
          </Tooltip>
        </div>
      }
      { retried>0 &&
        <div style={issueStyle}>
          <Tooltip title={fmtIssueTooltip(retried,"retried")}>
            <IconButton size={iconButtonSize}>
              <Badge badgeContent={retried} color={badgeColor} max={badgeMax}>
                <InputRetriedIcon fontSize={fontSize}/>
              </Badge>
            </IconButton>
          </Tooltip>
        </div>
      }
      { failed>0 &&
        <div style={issueStyle}>
          <Tooltip title={fmtIssueTooltip(failed,"failed")}>
            <IconButton size={iconButtonSize} onClick={handleClickFailed}>
              <Badge badgeContent={failed} color={badgeColor} max={badgeMax} showZero>
                <InputFailedIcon fontSize={fontSize} color='error'/>
              </Badge>
            </IconButton>
          </Tooltip>
        </div>
      }
    </div>
  );
}

